import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * JourneyBreadcrumbs Component
 *
 * Renders a navigation trail for the Zero Trust Journey.
 */
function JourneyBreadcrumbs({ crumbs, onNavigate }) {
  if (!crumbs || crumbs.length === 0) return null;

  return (
    <nav className="ztj-breadcrumbs" aria-label="Journey navigation">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        const isClickable = !isLast && onNavigate;

        return (
          <React.Fragment key={crumb.id}>
            {isClickable ? (
              <button
                type="button"
                className="ztj-breadcrumb"
                onClick={() => onNavigate(crumb.id)}
              >
                {formatLabel(crumb.label)}
              </button>
            ) : (
              <span className="ztj-breadcrumb ztj-breadcrumb--active">
                {formatLabel(crumb.label)}
              </span>
            )}
            {!isLast && (
              <span className="ztj-breadcrumb-separator">
                <ChevronRight size={14} />
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

/**
 * Format label for display
 */
function formatLabel(label) {
  if (!label) return '';

  // Handle function codes like ID_AUTH -> Authentication
  const functionLabels = {
    ID_AUTH: 'Authentication',
    ID_STORES: 'Identity Stores',
    ID_RISK: 'Risk Assessments',
    ID_ACCESS: 'Access Management',
    IDENTITY: 'Identity',
    DEVICES: 'Devices',
    NETWORKS: 'Networks',
    APPLICATIONS: 'Applications',
    DATA: 'Data'
  };

  if (functionLabels[label]) {
    return functionLabels[label];
  }

  // Handle maturity levels
  const levelLabels = {
    TRADITIONAL: 'Traditional',
    INITIAL: 'Initial',
    ADVANCED: 'Advanced',
    OPTIMAL: 'Optimal'
  };

  if (levelLabels[label]) {
    return levelLabels[label];
  }

  return label;
}

export default JourneyBreadcrumbs;
